import { render, staticRenderFns } from "./baidu-ueditor.vue?vue&type=template&id=12229302&scoped=true&"
import script from "./baidu-ueditor.vue?vue&type=script&lang=js&"
export * from "./baidu-ueditor.vue?vue&type=script&lang=js&"
import style0 from "./baidu-ueditor.vue?vue&type=style&index=0&id=12229302&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12229302",
  null
  
)

export default component.exports